"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFeatureFlags = exports.EClientTypes = void 0;
var EClientTypes;
(function (EClientTypes) {
    EClientTypes["DEFAULT"] = "default";
    EClientTypes["WEB_DESKTOP"] = "web-desktop";
    EClientTypes["WEB_MOBILE"] = "web-mobile";
    EClientTypes["NATIVE_IOS"] = "native-ios";
    EClientTypes["NATIVE_ANDROID"] = "native-android";
})(EClientTypes || (exports.EClientTypes = EClientTypes = {}));
// Add Feature Flags keys here
var EFeatureFlags;
(function (EFeatureFlags) {
    EFeatureFlags["CASHOUT_ENABLED"] = "CASHOUT_ENABLED";
    EFeatureFlags["GENERIC_SPORT_ENABLED"] = "GENERIC_SPORT_ENABLED";
    /**
     * @description Used for performance testing within ticket PLAT-628
     */
    EFeatureFlags["PERFORMANCE_PLAT628"] = "PERFORMANCE_PLAT628";
    /**
     * @description For enabling bonus on express feature for PLAT-1038
     */
    EFeatureFlags["BONUS_ON_EXPRESS_ENABLED"] = "BONUS_ON_EXPRESS_ENABLED";
    /** LINKED_EVENTS_ENABLED */
    EFeatureFlags["LINKED_EVENTS_ENABLED"] = "LINKED_EVENTS_ENABLED";
    EFeatureFlags["BROADCAST_ENABLED"] = "BROADCAST_ENABLED";
    EFeatureFlags["LANDING_APP"] = "LANDING_APP";
    /** PLAT-360 */
    EFeatureFlags["VIRTUAL_GAMES_PROVIDER_ENABLED"] = "VIRTUAL_GAMES_PROVIDER_ENABLED";
    /** PLAT-1514 */
    EFeatureFlags["SHOW_ALL_EVENT_PROBS"] = "SHOW_ANY_EVENT_PROBS";
    EFeatureFlags["ENTITY_TAGS_ENABLED"] = "ENTITY_TAGS_ENABLED";
    EFeatureFlags["BASKET_QUICK_BETS_ENABLED"] = "BASKET_QUICK_BETS_ENABLED";
    EFeatureFlags["BETS_AMOUNT_ENABLED"] = "BETS_AMOUNT_ENABLED";
    /** PLAT-1313 */
    EFeatureFlags["SSE_PROBABILITIES_UPDATE_OPTIMIZED"] = "SSE_PROBABILITIES_UPDATE_OPTIMIZED";
    /** PLAT-2332 */
    EFeatureFlags["DOWNLOAD_ANDROID_APP_BANNER_IN_HEADER_ENABLED"] = "DOWNLOAD_ANDROID_APP_BANNER_IN_HEADER_ENABLED";
    /**
     PLAT-2733, PLAT-4538
     Флаг для отмены автоматического сброса состояния корзины.
     Для разных регионов resetState должен работать по-разному. Поэтому resetState будет deprecated.
     Будут 2 разных action. Или сбросить все, но что-то сохранить. Или сбросить только конкретные поля.
    */
    EFeatureFlags["SKIP_RESET_BASKET_STATE"] = "SKIP_RESET_BASKET_STATE";
    /** PLAT-2460, PLAT-2461 */
    EFeatureFlags["FETCH_COMMON_DATA_NEW"] = "FETCH_COMMON_DATA_NEW";
    /** PLAT-2813 */
    EFeatureFlags["COMPUTE_PROBS_OPTIMIZATION"] = "COMPUTE_PROBS_OPTIMIZATION";
    /** PLAT-2780 */
    EFeatureFlags["GUEST_BASKET_ENABLED"] = "GUEST_BASKET_ENABLED";
    EFeatureFlags["NEW_CAPTCHA_ENABLED"] = "NEW_CAPTCHA_ENABLED";
    /** PLAT-3354 */
    EFeatureFlags["NEW_COUNTERS_ENDPOINT"] = "NEW_COUNTERS_ENDPOINT";
    /** PLAT-3351 */
    EFeatureFlags["NEW_RESULTS_ENDPOINT"] = "NEW_RESULTS_ENDPOINT";
    EFeatureFlags["NEW_OUTCOMES_ENABLED"] = "NEW_OUTCOMES_ENABLED";
    EFeatureFlags["NEW_EVENTS_ENDPOINT"] = "NEW_EVENTS_ENDPOINT";
    EFeatureFlags["NEW_TOURNAMENTS_ENDPOINT"] = "NEW_TOURNAMENTS_ENDPOINT";
    EFeatureFlags["NEW_OUTCOMES_STRUCT_ENABLED"] = "NEW_OUTCOMES_STRUCT_ENABLED";
    EFeatureFlags["BASKET_VALIDATION_IMPROVEMENTS"] = "BASKET_VALIDATION_IMPROVEMENTS";
    EFeatureFlags["BASKET_ERROR_HANDLE_IMPROVEMENTS"] = "BASKET_ERROR_HANDLE_IMPROVEMENTS";
    EFeatureFlags["NEW_SB_COMPETITORS_NAME_ENABLED"] = "NEW_SB_COMPETITORS_NAME_ENABLED";
    EFeatureFlags["EVENTS_EXCLUSION_ENABLED"] = "EVENTS_EXCLUSION_ENABLED";
    EFeatureFlags["ONLY_ORDINAR_ENABLED"] = "ONLY_ORDINAR_ENABLED";
    EFeatureFlags["COMPETITORS_CONSTRAINT_ENABLED"] = "COMPETITORS_CONSTRAINT_ENABLED";
    EFeatureFlags["IFRAME_BROADCAST_ENABLED"] = "IFRAME_BROADCAST_ENABLED";
    EFeatureFlags["TOKENIZE_SEARCH_QUERY_ENABLED"] = "TOKENIZE_SEARCH_QUERY_ENABLED";
    EFeatureFlags["SAVE_EMPTY_ORDINAR_BASKET_OUTCOMES"] = "SAVE_EMPTY_ORDINAR_BASKET_OUTCOMES";
    EFeatureFlags["ALL_HOT_PROBABILITIES_ENABLED"] = "ALL_HOT_PROBABILITIES_ENABLED";
    EFeatureFlags["IS_BETS_STATUSES_PARAM_ENABLED"] = "IS_BETS_STATUSES_PARAM_ENABLED";
})(EFeatureFlags || (exports.EFeatureFlags = EFeatureFlags = {}));
//# sourceMappingURL=types.js.map